import React, { useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { ApolloError, useMutation } from '@apollo/client'
import { toast } from 'react-toastify'
import BaseModal from '../Shared/BaseModal'
import Error from '../Shared/Error'
import { Box, Typography } from '@mui/material'
import { gql } from '@apollo/client'
import { IUserDataRow } from '../../components/HID/HIDUsersTable'
import { useForm } from 'react-hook-form'
import Input from '../Shared/Input'

type FormData = {
  comment: string
}

const DeleteSelectedHIDCards = ({
  items,
  refetch,
  open,
  onClose,
}: {
  items?: IUserDataRow[]
  refetch: () => void
  open: boolean
  onClose: () => void
}) => {
  const { t } = useTranslation(['hid'])
  const [errorMessage, setErrorMessage] = useState('')
  const successNotify = (message: string) => toast.dark(message)

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<FormData>()
  const message = watch('comment')

  const generateDeleteMutation = useCallback(() => {
    if (!items?.length) {
      return gql`mutation DeleteCards { __typename }`
    }
    const mutationFields = items
      .map(
        ({ login, deviceId }, index) => `
    DeleteMobileUserAccount${index}: DeleteMobileUserAccount(Login: "${login}", DeviceId: "${deviceId}", Comment: "${message}") {
      status
      error
      code
      message
    }
  `,
      )
      .join('\n')

    return gql`mutation DeleteCards{${mutationFields}}`
  }, [message, items])

  const [deleteCards, { loading }] = useMutation(generateDeleteMutation(), {
    onCompleted: () => {
      refetch()
      successNotify(t('card_deleted'))
    },
    onError: (error: ApolloError) => setErrorMessage(error.message),
  })

  const handleDelete = () => {
    onClose()
    deleteCards()
      .then(() => refetch())
      .catch(err => {
        setErrorMessage(String(err))
        refetch()
      })
  }

  return (
    <>
      {errorMessage && <Error errorMessage={errorMessage} />}
      <BaseModal
        confirmText={'btn:confirm'}
        open={open}
        handleClose={onClose}
        handleAccept={handleSubmit(handleDelete)}
      >
        <Box sx={{ p: '16px' }}>
          <Typography variant="subtitle1" sx={{ pb: '16px' }}>
            {t('delete_selected_cards_confirmation')}
          </Typography>
          <Input
            label={t('deletion_selected_cards_comment')}
            name={'comment'}
            control={control}
            errors={errors}
            multiline
            rows={2}
          />
        </Box>
      </BaseModal>
    </>
  )
}

export default DeleteSelectedHIDCards
